import { MatPaginator } from '@angular/material';
import { MatTableDataSource } from '@angular/material';
import { DadosArquivisticosService } from "app/components/dados-arquivisticos/dados-arquivisticos.service";
import { FormControl } from "@angular/forms";
import { FormArray } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { DialogConfirmComponent } from "app/components/dialog/dialog-confirm/dialog-confirm.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Validators } from "@angular/forms";
import { FormBuilder } from "@angular/forms";
import { FormGroup } from "@angular/forms";
import { ConfigurarPastaServiceService } from "app/configurar-pasta-service.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Component, OnInit, ViewChild } from "@angular/core";
import { v4 as uuidv4 } from "uuid";

@Component({
  selector: "app-vincularAspectoPontoAcesso",
  templateUrl: "./vincularAspectoPontoAcesso.component.html",
  styleUrls: ["./vincularAspectoPontoAcesso.component.scss"],
})
export class VincularAspectoPontoAcessoComponent implements OnInit {
  public clientId;
  public pontosDeAcesso = this.configPastaService.getDataPontoDeAcessoVinculo();
  nomesDistintosString: string;
  public datasourceAspecto: FormGroup;
  public modelos: any[] = [];
  public prefixModel: string;
  public isLoading = true;
  nodesByModel: any[];
  nodesFiltered = [];
  criarNovaProp = false;
  formGlobalUnico: FormGroup;
  propriedadeFormArray: FormArray;
  formGroups: any = {};
  aspectoName;
  types: any[] = [
    { value: "d:text", inputType: "text" },
    { value: "d:mltext", inputType: "text" },
    { value: "d:int", inputType: "number" },
    { value: "d:long", inputType: "number" },
    { value: "d:float", inputType: "number" },
    { value: "d:double", inputType: "number" },
    { value: "d:date", inputType: "date" },
    { value: "d:datetime", inputType: "date" },
    { value: "d:boolean", inputType: "boolean" },
  ];
  typeData = "text";
  listItems = [];
  propriedadesDoAspecto = [];
  displayedColumns = [
    "title",
    "name",
    "description",
    "type",
    "mandatory",
    "defaultValue"
  ];
  dataSource = new MatTableDataSource<any[]>([]);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  selectAspect = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private configPastaService: ConfigurarPastaServiceService,
    private _formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private arquivisticosService: DadosArquivisticosService
  ) {
    this.route.params.subscribe(
      (params) => (this.clientId = params["clientId"])
    );
  }

  ngOnInit() {
    const nomesDistintos = this.pontosDeAcesso.reduce((nomes, ponto) => {
      nomes.add(ponto.namePontoDeAcesso);
      return nomes;
    }, new Set());

    this.nomesDistintosString = Array.from(nomesDistintos).join(", ");

    this.formAspecto();
    this.listarModelos();
  }

  formAspecto() {
    this.datasourceAspecto = this._formBuilder.group({
      modeloAlfresco: ["", Validators.required],
      tipoPrimario: ["", Validators.required],
      pontosAcesso: [this.pontosDeAcesso],
    });
  }

  formGlobal() {
    this.formGlobalUnico = this._formBuilder.group({
      pontosAcesso: [this.pontosDeAcesso, Validators.required],
      aspectoId: [null, Validators.required],
      propriedadeFormArray: this._formBuilder.array([]),
    });

    setTimeout(() => {
      this.popularFormArrayProps();
    }, 500);
  }

  popularFormArrayProps() {
    let indice = 0;
    this.propriedadeFormArray = this.formGlobalUnico.get(
      "propriedadeFormArray"
    ) as FormArray;
    this.pontosDeAcesso.forEach((item, index) => {
      let nameFormat = this.formatarNomePropriedadeInit(
        this.pontosDeAcesso[index].namePontoDeAcesso
      );
      if (!this.formGroups[item.namePontoDeAcesso]) {
        this.formGroups[item.namePontoDeAcesso] = this._formBuilder.group({
          name: [this.prefixModel + ":" + nameFormat, Validators.required],
          title: [
            this.pontosDeAcesso[index].namePontoDeAcesso,
            Validators.required,
          ],
          description: [this.pontosDeAcesso[index].namePontoDeAcesso],
          type: ["", Validators.required],
          mandatory: ["", Validators.required],
          defaultValue: [""],
          constraint: [""],
          newProperty: [true],
        });
        indice++;

        this.propriedadeFormArray.push(
          this.createItemPreenchido(
            this.pontosDeAcesso[index].namePontoDeAcesso,
            this.prefixModel
          )
        );
      }
    });
  }

  createItemPreenchido(nome: string, prefix: string): FormGroup {
    let nameFormat = this.formatarNomePropriedadeInit(nome);
    return this._formBuilder.group({
      name: [
        { value: prefix + ":" + nameFormat, disabled: true },
        Validators.required,
      ],
      title: [nome, Validators.required],
      description: [nome],
      type: ["", Validators.required],
      mandatory: ["", Validators.required],
      defaultValue: [""],
      constraint: [""],
      newProperty: [true],
    });
  }

  formatarNomePropriedadeInit(e) {
    const str = e;
    const wordsIgnored = [
      " da ",
      " das ",
      " de ",
      " do ",
      " dos ",
      " Da ",
      " Das ",
      " De ",
      " Do ",
      " Dos ",
      " DOS ",
      " DAS ",
      " DE ",
      " DA ",
      " DO ",
      " ",
    ];
    const re = new RegExp("\\b(" + wordsIgnored.join("|") + ")\\b", "g");
    const nameFormated = str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()@¨+]/g, "")
      .replace(re, "")
      .replace(/[ ]{2,}/, " ");
    return nameFormated;
    //this.propForm.get("name").setValue(this.prefixModel + ":" + nameFormated);
  }

  listarModelos() {
    this.configPastaService.getModelosAlfresco().subscribe(
      (dados) => {
        dados.forEach((element) => {
          if (element.clientId == this.clientId) {
            this.modelos.push(element);
          }
          this.isLoading = false;
        });
      },
      (err) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  onSearch(value: string, mode: string) {
    const filter = value.toLowerCase();

    switch (mode) {
      case "TIPOPRIMARIO":
        this.nodesFiltered = this.nodesByModel.filter((node) =>
          node.title.toLowerCase().startsWith(filter)
        );
        break;
      default:
        break;
    }
  }

  onModelSelectionChange() {
    const idModelo = this.datasourceAspecto.get("modeloAlfresco").value;
    this.listarNodesByModel(idModelo);
    this.modelos.forEach((element) => {
      if (element.id === idModelo) {
        this.prefixModel = element.prefix;
      }
    });
    // console.log(this.prefixModel);
  }

  listarNodesByModel(modelId: number) {
    this.isLoading = true;
    this.configPastaService.getAspectByModelId(modelId).subscribe(
      (data) => {
        this.isLoading = false;
        this.nodesByModel = data;
        this.nodesFiltered = [...data];
      },
      (err) => {
        console.error(err);
        this.isLoading = false;
      }
    );
  }

  vincular() {
    this.configPastaService
      .vincularAspcetoPA(this.datasourceAspecto.value)
      .subscribe(
        (data) => {
          // console.log(data);
          this.openSnackBar("Tipo Documental vinculado ao aspecto !", false);
          this.router.navigate(["/tabela-matriz/", this.clientId]);
        },
        (err) => {
          console.error(err);
          this.openSnackBar("Erro ! ", true);
          this.isLoading = false;
        }
      );
  }

  save() {
    this.isLoading = true;
    if (this.datasourceAspecto.valid) {
      const dialogRef = this.dialog.open(DialogConfirmComponent, {
        data: {
          name: "Deseja criar uma nova Propriedade para o aspecto: " + this.aspectoName + " ?",
          from: "vincular-aspecto-ponto-acesso.ts",
        },
      });
      // const snack = this.snackBar.open('Snack bar open before dialog');

      dialogRef.afterClosed().subscribe((confirmed: any) => {
        // console.log(confirmed.apagar);
        if (confirmed.apagar === true) {
          this.desabilitarCampos();
        } else {
          //alert("Você não deseja apagar essa propriedade !");
          this.vincular();
        }
        this.isLoading = false;
      });
    } else {
      this.isLoading = false;
      this.openSnackBar("Preencha todos os campos obrigatórios !", true);
    }
  }

  desabilitarCampos() {
    // console.log(this.datasourceAspecto.value);
    this.datasourceAspecto.disable();
    this.criarNovaProp = true;
    this.formGlobal();
  }

  removeForm(i) {
    this.propriedadeFormArray = this.formGlobalUnico.get(
      "propriedadeFormArray"
    ) as FormArray;
    // this.propriedadeFormArray.push(this.createItem());
    if (i > 0) {
      this.propriedadeFormArray.removeAt(i);
    } else {
      this.openSnackBar("Não é permitido remover a primeira propriedade", true);
    }
  }

  keyFunc(e, i) {
    this.formatarNomePropriedade(e, i);
  }

  formatarNomePropriedade(e, i) {
    const str = e.target.value;
    const wordsIgnored = [
      " da ",
      " das ",
      " de ",
      " do ",
      " dos ",
      " Da ",
      " Das ",
      " De ",
      " Do ",
      " Dos ",
      " DOS ",
      " DAS ",
      " DE ",
      " DA ",
      " DO ",
      " ",
    ];
    const re = new RegExp("\\b(" + wordsIgnored.join("|") + ")\\b", "g");
    const nameFormated = str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()@¨+]/g, "")
      .replace(re, "")
      .replace(/[ ]{2,}/, " ");

    let formArrayProps = this.formGlobalUnico.get(
      "propriedadeFormArray"
    ) as FormArray;
    let arrayIndex = formArrayProps.controls[i] as FormGroup;
    arrayIndex.get("name").setValue(this.prefixModel + ":" + nameFormated);
  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, "", {
      horizontalPosition: "right",
      verticalPosition: "top",
      duration: 3000,
      panelClass: isErr ? ["error-snackbar"] : ["success-snackbar"],
    });
  }

  reset() {
    this.router.navigate(["/tabela-matriz/", this.clientId]);
  }

  onChangeTypeData(typeSelected) {
    const obj = this.types.find((e) => e.value === typeSelected);
    this.typeData = obj.inputType;
  }

  onChangeConstraint(constraint, i) {
    let formArrayProps = this.formGlobalUnico.get(
      "propriedadeFormArray"
    ) as FormArray;
    let arrayIndex = formArrayProps.controls[i] as FormGroup;

    arrayIndex.addControl(
      "constraint",
      new FormControl("", Validators.required)
    );
    if (constraint === "LIST") {
      arrayIndex.get("constraint").setValue("LIST");
      arrayIndex.removeControl("regex");
      arrayIndex.addControl("list", this._formBuilder.array([]));
    } else if (constraint === "REGEX") {
      arrayIndex.get("constraint").setValue("REGEX");
      arrayIndex.removeControl("list");
      this.listItems = [];
      arrayIndex.addControl("regex", new FormControl("", Validators.required));
    } else {
      arrayIndex.removeControl("list");
      this.listItems = [];
      arrayIndex.removeControl("regex");
      arrayIndex.removeControl("constraint");
    }
  }

  deleteItem(i, index) {
    let formArrayProps = this.formGlobalUnico.get(
      "propriedadeFormArray"
    ) as FormArray;
    let arrayIndex = formArrayProps.controls[i] as FormGroup;
    let list = arrayIndex.get("list") as FormArray;
    if (index > 0) {
      list.removeAt(index);
    } else {
      this.openSnackBar("O primeiro item da lista é obrigatório !", true);
    }
  }

  addItemList(i) {
    let formArrayProps = this.formGlobalUnico.get(
      "propriedadeFormArray"
    ) as FormArray;
    let arrayIndex = formArrayProps.controls[i] as FormGroup;
    let list = arrayIndex.get("list") as FormArray;
    list.push(this._formBuilder.control(""));
  }

  addItem(): void {
    this.propriedadeFormArray = this.formGlobalUnico.get(
      "propriedadeFormArray"
    ) as FormArray;
    this.propriedadeFormArray.push(this.createItem());
  }

  createItem(): FormGroup {
    return this._formBuilder.group({
      name: [{ value: "", disabled: true }, Validators.required],
      title: ["", Validators.required],
      description: [""],
      type: ["", Validators.required],
      mandatory: ["", Validators.required],
      defaultValue: [""],
      constraint: [""],
      newProperty: [true],
    });
  }

  setConstraints() {
    let formArrayProps = this.formGlobalUnico.get(
      "propriedadeFormArray"
    ) as FormArray;

    const constraintNula: any = {
      expression: "",
      listaItens: "",
      type: "",
    };

    for (let i = 0; i < formArrayProps.length; i++) {
      let arrayIndex = formArrayProps.controls[i] as FormGroup;
      let constraint;
      if (arrayIndex.get("constraint") != null) {
        switch (arrayIndex.get("constraint").value) {
          case "none":
            // // console.log('none');
            break;
          case "LIST":
            constraint = { ...constraintNula };
            constraint.name = `${this.prefixModel}:LIST_${uuidv4()}`;
            constraint.expression = null;
            const listaItems = [];
            const lista: any[] = arrayIndex.value.list;
            lista.forEach((el) => {
              listaItems.push({ id: null, value: el });
            });
            constraint.listaItens = listaItems;
            constraint.type = "LIST";
            arrayIndex.get("constraint").setValue(constraint);
            break;
          case "REGEX":
            constraint = { ...constraintNula };
            constraint.name = `${this.prefixModel}:REGEX_${uuidv4()}`;
            constraint.expression = arrayIndex.get("regex").value;
            constraint.listaItens = null;
            constraint.type = "REGEX";
            arrayIndex.get("constraint").setValue(constraint);
            break;
        }
      }
      arrayIndex.get("name").enable();
      if (arrayIndex.get("constraint") != null) {
        if (arrayIndex.get("constraint").value === "") {
          arrayIndex.removeControl("constraint");
        }
      }
    }
  }

  saveAll() {
    this.isLoading = true;
    this.setConstraints();
    this.formGlobalUnico
      .get("aspectoId")
      .setValue(this.datasourceAspecto.get("tipoPrimario").value);
    setTimeout(() => {
      // console.log(this.formGlobalUnico.value);
      this.configPastaService
        .vincularAspcetoNovaPropriedadePA(this.formGlobalUnico.value)
        .subscribe(
          (res) => {
            // console.log(res);
            this.isLoading = false;
            this.openSnackBar(
              "Tipo Documental vinculado ao aspecto e Propriedade criada !",
              false
            );
            this.router.navigate(["/tabela-matriz/", this.clientId]);
          },
          (err) => {
            this.isLoading = false;
            console.error(err);
            this.openSnackBar("Erro ! ", true);
          }
        );
    }, 1000);
  }

  onAspectoSelectionChange(event) {
    let idAspecto = event.value;
    this.arquivisticosService.listarNodeDicionario(idAspecto).subscribe(
      (res) => {
        // console.log(res.propriedades);
        this.aspectoName = res.title;
        this.propriedadesDoAspecto = res.propriedades;
        this.dataSource.data = res.propriedades;
        this.selectAspect = true;
      },
      (err) => {
        console.error(err);
      }
    );
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/vincularAspectoPontoAcesso/vincularAspectoPontoAcesso.component.ts